import { render, staticRenderFns } from "./learning_detail.vue?vue&type=template&id=94ccfc36&"
import script from "./learning_detail.vue?vue&type=script&lang=js&"
export * from "./learning_detail.vue?vue&type=script&lang=js&"
import style0 from "./learning_detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports